import { useQuery } from "@tanstack/react-query";
import { useApi } from "~/api/provider";

export interface CollectionInput {
  id: string;
  collectionId: string;
  kind: "news";
  corpusTeamId: string;
  enabled: boolean;
  deposited: number;
  total: number;
  preservedEdits: number;
  lastSyncedAt: string | null;
  error: string | null;
  canExplore: boolean;
  canManage: boolean;
}

export const collectionInputKey = (id: string) => ["collection-input", id] as const;

export function useCollectionInput(collectionId: string) {
  const api = useApi();
  return useQuery({
    queryKey: collectionInputKey(collectionId),
    queryFn: async () => {
      const result = (await api.research.post("channels.collections.get", { collectionId })) as {
        data: CollectionInput | null;
      };
      return result.data ?? null;
    },
    retry: false,
    staleTime: 15_000,
    refetchInterval: 30_000,
  });
}

export function safeNewsView(value: unknown): string {
  return typeof value === "string" &&
    value.startsWith("/") &&
    !value.startsWith("//") &&
    !value.includes("\\") &&
    value.length <= 2048
    ? value
    : "/news";
}

export function acceptsNewsMessage(
  event: Pick<MessageEvent, "origin" | "source">,
  frame: Window | null,
  origin: string,
): boolean {
  return frame !== null && event.origin === origin && event.source === frame;
}
